import { Bookmark } from 'lucide-react';
import { PageHeader } from '../components/ui/PageHeader';
import { ComingSoon } from '../components/ui/ComingSoon';

export function SavedKeywordsPage() {
  return (
    <>
      <PageHeader
        icon={Bookmark}
        title="Saved Keywords"
        description="Your keyword lists — tag, folder, and export."
      />
      <ComingSoon what="Saved Keywords UI" />
    </>
  );
}
